// ** React Imports
import { Fragment } from "react";

// ** Dropdowns Imports
import UserDropdown from "./UserDropdown";

// ** Third Party Components
import { Sun, Moon } from "react-feather";

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap";

const NavbarUser = (props) => {
    // ** Props
    const { skin, setSkin } = props;

    // ** Function to toggle Theme (Light/Dark)

    return (
        <Fragment>
            <ul className="nav navbar-nav align-items-center ms-auto">
                <UserDropdown />
            </ul>
        </Fragment>
    );
};
export default NavbarUser;
